import React from 'react';
import ClassCard from './ClassCard';


class Compare extends React.Component {
    
    render() {
        return (
            <div className="row">
                {this.props.compares.map((compare) => {
                    return (
                        <div className="col-lg-4" key={compare.CLASS_NBR}>
                            <ClassCard key={compare.CLASS_NBR} cls={compare} removeCompare={this.props.removeCompare} downrangeLocations={this.props.downrangeLocations}/>
                        </div>
                    );
                })}
            </div>
        );
    }
}

export default Compare;